/* eslint-disable react/prop-types */
import React from 'react';
import { Form, Button } from 'react-bootstrap5';

import {
  ErrorMessage,
  Field,
  useField,
} from 'formik';

export default function HorizontalNumberField(props) {
  const {
    name, label, placeholder, type, hint, required, className, ...rest
  } = props;

  const [field, meta, helpers] = useField(props);
  const { setValue } = helpers;

  const onMinusClick = () => {
    if (field.value > 0) {
      setValue(field.value - 1);
    }
  };

  const onPlusClick = () => {
    setValue(field.value + 1);
  };

  const errorClass = meta.error !== undefined && meta.touched ? 'is-invalid' : '';

  return (
    <Form.Group className="mb-3" controlId="formBasicEmail">
      {label && (
        <Form.Label>
          <>
            {label}
            {required && <abbr className="ms-1" title="required">*</abbr>}
          </>
        </Form.Label>
      )}

      <div className={`d-flex gap-2 ${className} ${errorClass}`}>
        <Button variant="outline-primary" onClick={onMinusClick}>
          <div className="icon-with-text">
            <i className="small-icon minus-icon" />
          </div>
        </Button>

        <Field
          autoComplete="off"
          className={`form-control text-center w-50 without-arrows ${errorClass}`}
          type={type || 'number'}
          name={name}
          placeholder={placeholder || ''}
          {...rest}
        />

        <Button variant="outline-primary" onClick={onPlusClick}>
          <div className="icon-with-text">
            <i className="small-icon clone-icon" />
          </div>
        </Button>
      </div>

      {hint && <Form.Text className="text-muted">{hint}</Form.Text>}

      <ErrorMessage
        name={name}
        render={(msg) => <Form.Control.Feedback type="invalid">{msg}</Form.Control.Feedback>}
      />
    </Form.Group>
  );
}
